/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

export const Spacer = styled.div`
  height: ${(props) => (props.vertical ? props.height || '20px' : '0px')};
  width: ${(props) => (props.horizontal ? props.width || '20px' : '0px')};
`;

export const NormalText = styled.div`
  font-size: ${(props) => props.fontSize || '12px'};
  color: ${(props) => props.color || '#000000'};
  font-family: Source Sans Pro, IBM Plex Sans, sans-serif;
`;

export const BoldText = styled.p`
  font-size: ${(props) => props.fontSize || '12px'};
  font-weight: bold;
  font-family: Source Sans Pro, IBM Plex Sans, sans-serif;
`;
